export default __webpack_public_path__ + "static/media/Mystic's Girdle of the Bloody Stone.b21610c7.jpg";